import axios from "axios";
import { Slide } from "../types";
import { useQuery } from "react-query";
export const api = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}/api/report/`,
});

export const getTemplate = (params: { fileName: string }) =>
  api
    .get<{ templateName: string; pages: Slide[] }>("/template", { params })
    .then((res) => ({ ...res.data, templateName: params.fileName }));

export const useTemplate = (name: string) => {
  return useQuery(`tpl-${name}`, async () => {
    return getTemplate({ fileName: name });
  });
};
